import 'bootstrap/js/dist/modal';

export default function featured_info_window() {
    $('.feature-icon').mouseenter(function (e) {
        const offset = $(this).offset();
        let offset_top = offset.top - 20;
        let offset_left = offset.left + 160;
        let width = 535;
        let height = 604;
        const ratio = width/height;
        if ($(window).width() < 992) {
            offset_top = offset.top + 40;
            offset_left = $(window).width() - 535;
        }
        if ($(window).width() < 535) {
            width = $(window).width();
            height = width / ratio;
            offset_left = 0;
        }
        $('body').append(`<div id="featured-info" style="position:absolute;top:${offset_top}px;left:${offset_left}px;width:${width}px;height:${height}px;"></div>`);
        $(this).find('.feature-icon-content').clone().appendTo("#featured-info");
    }).mouseleave( function () {
        $('#featured-info').remove();
    } );
}